



































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import StatusWindow from "./status-window";

@Component({ name: "modal-window" })
export default class ModalWindowComponent extends Vue {
  @Prop({ default: "title" })                         title: string;
  @Prop({ default: false, type: Boolean })          visible: boolean;
  @Prop({ default: true, type: Boolean })          showCloseBtn: boolean;
  @Prop({ default: "300px", type: String })           width: string;
  @Prop({ default: StatusWindow.Text, type: Number })  type: StatusWindow;

  @Prop({ default: false, type: Boolean })          noButton: boolean;
  @Prop({ default: true, type: Boolean })          showHeaderTitle: boolean;
  @Prop({ default: true, type: Boolean })          autoClose: boolean;
  
  innerVisible = this.visible;
  clickModal = true;

  @Watch("visible")
  onChangeVisible() {
    this.innerVisible = this.visible;
  }
  @Watch("innerVisible")
  onChangeVisible(visible: boolean) {
    this.innerVisible = visible;
    this.clickModal = true;
  }

  mounted(){
    document.addEventListener('keydown', this.onKeyDown);
    document.body.addEventListener("click", this.clickOutside.bind(this));
  }
  befoDestroy(){
    document.removeEventListener('keydown', this.onKeyDown);
    document.body.removeEventListener("click", this.clickOutside.bind(this));
  }

  hasSlotData() {
    return this.$slots.button;
  }

  closeWindow() {
    this.innerVisible = false;
    this.$emit("close");
    return false;
  }
  
  onCancel() {
    this.$emit("cancel");
    this.closeWindow();
    return false;
  }
  onOk() {
    this.$emit("ok");
    if(this.autoClose) {
      this.closeWindow();
    }
    return false;
  }
  onKeyDown(evt:any){
    if (this.innerVisible){
      evt = evt || window.event;
      var isEscape = false;
      if ("key" in evt) {
        isEscape = (evt.key === "Escape" || evt.key === "Esc");
      } else {
        isEscape = (evt.keyCode === 27);
      }
      if (isEscape) {
       this.onCancel()
      }
    }
  }

  getWindowsType(type: StatusWindow) {
    var value = "";
    switch (type) {
      case 1:
        //text
        value = "";
        break;
      case 2:
        //error
        value = "icon-icon_error";
        break;
      case 3:
        //warning
        value = "icon-icon_warning";
        break;
      case 4:
        //info
        value = "icon-icon_info";
        break;
      default:
        break;
    }

    return value;
  }
  click() {
    this.clickModal = true;
  }
  clickOutside(event: any) {
    if (!this.clickModal) {
      this.$emit('onClickOutside'); 
    } 
    this.clickModal = false;
  }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./~/modal-window/src/modal-window.vue